module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[64]307.75ba83e.woff2";